import { twJoin } from 'tailwind-merge';

import { ChevronLeftIcon } from '@/core/tamagoshiTailwind/icons/ChevronLeftIcon';
import { ChevronRightIcon } from '@/core/tamagoshiTailwind/icons/ChevronRightIcon';
import { twMerge } from '@/core/tamagoshiTailwind/util/twMerge';

type Props = {
  /** Classname for the component */
  className?: string;
  /** Whether the left arrow is disabled */
  disabledLeft?: boolean;
  /** Whether the right arrow is disabled */
  disabledRight?: boolean;
  /** Function to call when the left arrow is clicked */
  onLeftClick: () => void;
  /** Function to call when the right arrow is clicked */
  onRightClick: () => void;
  /** Accessible title for the left button */
  titleLeft: string;
  /** Accessible title for the right button */
  titleRight: string;
};

const buttonClassName = twJoin(
  `flex size-[48px] flex-shrink-0 items-center justify-center rounded-full
  border border-foundation-primary bg-foundation-inverted
  hover:border-foundation-tertiary disabled:cursor-default
  disabled:border-foundation-disabled disabled:bg-foundation-disabled
  disabled:text-foundation-disabled`,
);

/**
 * Left and right controls to browse horizontal content.
 *
 * See the related [Figma][figma] for more details.
 *
 * [figma]: https://www.figma.com/design/KAiRlBccr6bFYmKby9wQrR?node-id=15439-3553
 */
export const Arrows = ({
  className,
  disabledLeft,
  disabledRight,
  onLeftClick,
  onRightClick,
  titleLeft,
  titleRight,
}: Props) => (
  <div className={twMerge('flex gap-s', className)}>
    <button
      aria-label={titleLeft}
      className={buttonClassName}
      disabled={disabledLeft}
      onClick={onLeftClick}
      title={titleLeft}
    >
      <ChevronLeftIcon />
    </button>
    <button
      aria-label={titleRight}
      className={buttonClassName}
      disabled={disabledRight}
      onClick={onRightClick}
      title={titleRight}
    >
      <ChevronRightIcon />
    </button>
  </div>
);

Arrows.displayName = 'Arrows';
